import React from 'react';

interface ErrorMessageProps {
	message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
	return (
		<div className="error-message">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="25"
				height="25"
				viewBox="0 0 25 25"
				fill="none"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.5 0C5.59636 0 0 5.59636 0 12.5C0 19.4036 5.59636 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59636 19.4036 0 12.5 0ZM12.5 23.7322C6.29655 23.7322 1.26779 18.7034 1.26779 12.5C1.26779 6.29655 6.29655 1.26779 12.5 1.26779C18.7034 1.26779 23.7322 6.29655 23.7322 12.5C23.7322 18.7034 18.7034 23.7322 12.5 23.7322Z"
					fill="#EA0A0A"
				/>
				<path
					d="M12.6031 17.5562C12.0284 17.5562 11.5625 18.0222 11.5625 18.5969C11.5625 19.1716 12.0284 19.6375 12.6031 19.6375C13.1778 19.6375 13.6438 19.1716 13.6438 18.5969C13.6438 18.0222 13.1778 17.5562 12.6031 17.5562ZM13.4937 10.375V6.25H11.7125V10.375L12.1813 15.8875H13.025L13.4937 10.375Z"
					fill="#EA0A0A"
				/>
			</svg>
			<p
				className="labels-caption"
				dangerouslySetInnerHTML={{
					__html: message,
				}}
			></p>
		</div>
	);
};

export default ErrorMessage;
